import { Card, CardContent, CardHeader, CardTitle } from "@tonic/shared/components/ui";
import { 
  Table,
  TableHeader,
  TableBody,
  TableRow,
  TableHead,
  TableCell
} from "@tonic/shared/components/ui";
import { format } from 'date-fns';
import PropTypes from 'prop-types';

export function HistoryTab({ product }) {
  // TODO: Replace with actual API calls
  const history = [
    {
      id: '1',
      type: 'update',
      description: 'Updated product price from $99 to $129',
      user: 'John Doe',
      timestamp: new Date('2024-02-01T10:00:00')
    },
    {
      id: '2',
      type: 'reCommerce',
      description: 'Product was repaired and returned to inventory',
      user: 'Jane Smith',
      timestamp: new Date('2024-01-28T15:30:00')
    }
  ];

  const reCommerceStats = {
    totalResold: 15,
    averageResalePrice: 89.99,
    totalRepairs: 8,
    totalRentals: 25,
    totalRefills: 12
  };

  return (
    <div className="space-y-6">
      <Card>
        <CardHeader>
          <CardTitle>Re-Commerce Statistics</CardTitle>
        </CardHeader>
        <CardContent>
          <div className="grid grid-cols-2 md:grid-cols-3 gap-6">
            <div>
              <p className="text-sm font-medium text-muted-foreground">Total Resold</p>
              <p className="text-2xl font-bold">{reCommerceStats.totalResold}</p>
            </div>
            <div>
              <p className="text-sm font-medium text-muted-foreground">Average Resale Price</p>
              <p className="text-2xl font-bold">${reCommerceStats.averageResalePrice}</p>
            </div>
            <div>
              <p className="text-sm font-medium text-muted-foreground">Total Repairs</p>
              <p className="text-2xl font-bold">{reCommerceStats.totalRepairs}</p>
            </div>
            <div>
              <p className="text-sm font-medium text-muted-foreground">Total Rentals</p>
              <p className="text-2xl font-bold">{reCommerceStats.totalRentals}</p>
            </div>
            <div>
              <p className="text-sm font-medium text-muted-foreground">Total Refills</p>
              <p className="text-2xl font-bold">{reCommerceStats.totalRefills}</p>
            </div>
          </div>
        </CardContent>
      </Card>

      <Card>
        <CardHeader>
          <CardTitle>Change History</CardTitle>
        </CardHeader>
        <CardContent>
          <Table>
            <TableHeader>
              <TableRow>
                <TableHead>Type</TableHead>
                <TableHead>Description</TableHead>
                <TableHead>User</TableHead>
                <TableHead>Date</TableHead>
              </TableRow>
            </TableHeader>
            <TableBody>
              {history.map((entry) => (
                <TableRow key={entry.id}>
                  <TableCell>
                    <span className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium
                      ${entry.type === 'update' ? 'bg-blue-100 text-blue-800' : 'bg-green-100 text-green-800'}`}
                    >
                      {entry.type === 'update' ? 'Update' : 'Re-Commerce'}
                    </span>
                  </TableCell>
                  <TableCell>{entry.description}</TableCell>
                  <TableCell>{entry.user}</TableCell>
                  <TableCell>{format(entry.timestamp, 'MMM d, yyyy h:mm a')}</TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </CardContent>
      </Card>
    </div>
  );
}

HistoryTab.propTypes = {
  product: PropTypes.shape({
    id: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
    sku: PropTypes.string.isRequired
  }).isRequired
}; 